import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function preEntry(items, inboundBatch) {
  const res = await axios.post(`${API_BASE}/inbound/pre-entry`,
    { items, inbound_batch: inboundBatch },
    { headers: authHeader() }
  );
  return res.data;
}

export async function getPendingItems(inboundBatch = null) {
  const params = {};
  if (inboundBatch) params.inbound_batch = inboundBatch;
  const res = await axios.get(`${API_BASE}/inbound/pending`, { headers: authHeader(), params });
  return res.data;
}

export async function receiveItem(itemId, zoddle_barcode) {
  const res = await axios.post(`${API_BASE}/inbound/receive/${itemId}`,
    { zoddle_barcode },
    { headers: authHeader() }
  );
  return res.data;
}

export async function rejectItem(itemId, reason = 'damaged_on_arrival') {
  const res = await axios.post(`${API_BASE}/inbound/reject/${itemId}`,
    { reason },
    { headers: authHeader() }
  );
  return res.data;
}

export async function bulkReceive(itemIds) {
  const res = await axios.post(`${API_BASE}/inbound/bulk-receive`,
    { item_ids: itemIds },
    { headers: authHeader() }
  );
  return res.data;
}

export async function suggestBin(itemId) {
  const res = await axios.get(`${API_BASE}/inbound/suggest-bin/${itemId}`, { headers: authHeader() });
  return res.data;
}

export async function putawayItem(itemId, binId) {
  const res = await axios.post(`${API_BASE}/inbound/putaway/${itemId}`,
    null,
    { headers: authHeader(), params: { bin_id: binId } }
  );
  return res.data;
}

export async function bulkPutaway(items) {
  const res = await axios.post(`${API_BASE}/inbound/bulk-putaway`,
    { items },
    { headers: authHeader() }
  );
  return res.data;
}

export async function getRejectedItems(inboundBatch = null) {
  const params = {};
  if (inboundBatch) params.inbound_batch = inboundBatch;
  const res = await axios.get(`${API_BASE}/inbound/rejected`, { headers: authHeader(), params });
  return res.data;
}

export async function getAwaitingPutaway(filters = {}) {
  const res = await axios.get(`${API_BASE}/inbound/awaiting-putaway`, {
    headers: authHeader(),
    params: filters
  });
  return res.data;
}

export async function markMissing(itemId) {
  const res = await axios.post(`${API_BASE}/inbound/mark-missing/${itemId}`,
    null,
    { headers: authHeader() }
  );
  return res.data;
}

export function rejectedReportUrl(batchName) {
  // Direct GET — frontend opens this in a new tab to trigger CSV download.
  // Auth header still required, so we use axios + blob.
  return `${API_BASE}/inbound/rejected-report/${encodeURIComponent(batchName)}`;
}

export async function downloadRejectedReport(batchName) {
  const res = await axios.get(rejectedReportUrl(batchName), {
    headers: authHeader(),
    responseType: 'blob',
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${batchName}_rejected_report.csv`;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}
